import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import * as Redux from 'react-redux';
import * as ROUTES from '../../router/Routes';
import ContainerTemplate from '../../widgets/template/Container';
import BotonComponent from '../dashboard/components/BotonNuevo';
import { allCarnetAction } from './CarnetAction';
import { PARAMS_CARNET } from './CarnetReducer';

const ImpresionCarnet = () => {
  const dispatch = Redux.useDispatch();

  const carnetStore = Redux.useSelector((state) => state.carnet);

  useEffect(() => {
    const fetchData = async () => {
      // Carnets
      if (carnetStore.all && carnetStore.all.length === 0) {
        const payload = {};
        dispatch({ type: PARAMS_CARNET, payload });
        await allCarnetAction(dispatch, payload);
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ContainerTemplate
      active={ROUTES.impresionCarnet}
      routes={[ROUTES.controlEstudios]}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} md={12}>
          <BotonComponent
            click={async () => {
              await allCarnetAction(dispatch, {
                idEntidad: null,
              });
            }}
            disabled={carnetStore.loadingAll}
            white
            refreshIcon
            text={carnetStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
          />
        </Grid>
      </Grid>
    </ContainerTemplate>
  );
};

export default ImpresionCarnet;
